import { useEffect, useState } from "react";

/**
 * Hook to check if Google Play Billing is available in the current context
 * This will be true when the app is running as a Trusted Web Activity from the Play Store
 */
export function useGooglePlayBillingAvailability(): {
  isAvailable: boolean;
  isLoading: boolean;
} {
  const [isAvailable, setIsAvailable] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkPlayBillingAvailability = async () => {
      if (typeof window === "undefined") {
        setIsLoading(false);
        return;
      }

      if (!("getDigitalGoodsService" in window)) {
        setIsAvailable(false);
        setIsLoading(false);
        return;
      }

      try {
        // @ts-ignore - Digital Goods API is not yet in TypeScript defs
        const _service = await window.getDigitalGoodsService(
          "https://play.google.com/billing"
        );
        setIsAvailable(true);
      } catch (error) {
        setIsAvailable(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkPlayBillingAvailability();
  }, []);

  return { isAvailable, isLoading };
}
